const CACHE_SECRET = 'ec-web-console-storefront-2026'

function getNonce() {
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
}

function toBase64(value) {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(value, 'utf8').toString('base64')
  }
  return btoa(unescape(encodeURIComponent(value)))
}

function fromBase64(value) {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(value, 'base64').toString('utf8')
  }
  return decodeURIComponent(escape(atob(value)))
}

function xorText(value, nonce) {
  const key = `${CACHE_SECRET}:${nonce || ''}`
  return String(value || '')
    .split('')
    .map((char, index) => String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(index % key.length)))
    .join('')
}

function encodePayload(data) {
  const nonce = getNonce()
  const json = JSON.stringify(data)
  return {
    __schema: 'ec.web.cache.payload',
    __version: 2,
    __nonce: nonce,
    __issuedAt: Date.now(),
    __payload: toBase64(xorText(json, nonce))
  }
}

function decodePayload(wrapper) {
  if (!wrapper || wrapper.__schema !== 'ec.web.cache.payload' || !wrapper.__payload) {
    return null
  }
  const json = xorText(fromBase64(wrapper.__payload), wrapper.__nonce)
  return JSON.parse(json)
}

function readJson(storage, key) {
  if (!storage || !key) return null
  const raw = storage.getItem(key)
  if (!raw) return null
  try {
    return decodePayload(JSON.parse(raw))
  } catch (e) {
    return null
  }
}

function writeJson(storage, key, data) {
  if (!storage || !key) return
  storage.setItem(key, JSON.stringify(encodePayload(data)))
}

function remove(storage, key) {
  if (!storage || !key) return
  storage.removeItem(key)
}

module.exports = {
  readJson,
  writeJson,
  remove
}
